<form novalidate [formGroup]="lobbyCheckInForm">
  <kendo-dialog [title]="popupTitile" *ngIf="_dialogOpened" (close)="close()">
    <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
      <div class="lobby-check-in-popup-wrapper">
        <div class="scrollable-content">
          <div class="row">
            <!-- Visitor Information -->
            <div class="col-md-6">
              <!--Title-->
              <h6 class="sub-heading">{{'_Lobby_Visitor_Information_Text_' | translate }}</h6>
            <!-- Location Dropdown if user Not signed In-->
              <div class="row mt-3" *ngIf="!isUserSigned">
                <div class="col-md-6 input">
                <app-location-selector [isLobby]="true" [selectorDisabled]="disableSelector" (onLocationsData)="onLocationsFetched($event)"  labelText="{{'_Lobby_Check_In_Location_Text_' | translate }}" hoverText=""  [isDisableParentClick]="true"  [selectableTypes]="[5]" [dispatchStateEvent]="false"   [hideBranchLess]="true"
                [selectedLocationId]="selectedLocationId"  [isIncludeFloatLocation]="false"   [selectedLocationName]="selectedLocationName" (onChange)="handleLocationData($event)" (onChange)="handleLocationData($event)"
                ></app-location-selector>
            </div>
            </div>

              <!-- Account Number -->
              <div id="enableAccountNumber" class="input"
                *ngIf="lobbyConfiguration && lobbyConfiguration.EnableAccountNumber">
                <label for="accountNumber">{{'_Account_Number_Field_Text_' | translate}}</label>
                <input id="accountNumber" class="form-control" formControlName="AccountNumber" 
                  type="text" maxlength="50" (input)="onAccountNumberChange($event)"
                  (blur)="blur()" (focusout)="accountNumberFocusOut()" app-filter
                  input-field-on-past-filter (keypress)="prevenetSpaceAtBegining($event)"
                  (keydown)="onAccountNumberKeydown()"
                  pattern="^((?=[^<>&])[A-Za-z0-9`\s\|!@?#\\$\/\%\[\]^_\*\(\)~=\{\}:;+'&quot;\.\-;,])*$"/>
                <div class="cc-validation">
                  <div id="accountNumberValidationMessage" *ngIf="displayMessage.AccountNumber">
                    {{ displayMessage.AccountNumber }}
                  </div>
                </div>
              </div>

              <!-- First Name & Last Name -->
              <div class="row">
                <div class="col-md-6 input">
                  <label for="firstName">{{'_General_User_First_Name_Text_' | translate }}
                    <span tabindex="-1" class="required-field">*</span>
                  </label>
                  <input id="firstName" class="form-control" formControlName="FirstName" type="text" maxlength="50"
                    (keypress)="keypress($event)" (blur)="blur()" input-field-on-past-filter
                    pattern="^((?=[^<>&])[A-Za-z0-9`\s\|!@?#\\$\/%\[\]^_*\(\)~=\{\}:;+'&quot;.\-;,])*$" />
                  <div class="cc-validation">
                    <div id="firstNameErrorMessage" *ngIf="displayMessage.FirstName">
                      {{ displayMessage.FirstName }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 input">
                  <label for="lastName">{{'_General_User_Last_Name_Text_' | translate }}
                    <span tabindex="-1" class="required-field">*</span>
                  </label>
                  <input id="lastName" class="form-control" formControlName="LastName" type="text" maxlength="50"
                    (keypress)="keypress($event)" (blur)="blur()" input-field-on-past-filter
                    pattern="^((?=[^<>&])[A-Za-z0-9`\s\|!@?#\\$\/%\[\]^_*\(\)~=\{\}:;+'&quot;.\-;,])*$" />
                  <div class="cc-validation">
                    <div id="lastNameErrorMessage" *ngIf="displayMessage.LastName">
                      {{ displayMessage.LastName }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- Phone Number -->
              <div class="row">
                <div id="enablePhoneNumber" class="col-md-6 input"
                  *ngIf="lobbyConfiguration && lobbyConfiguration.EnablePhoneNumber">
                  <label for="phoneNumber">{{'_General_Phone_Number_Column_Title_' | translate }}</label>
                  <input id="phoneNumber" class="form-control" formControlName="PhoneNumber" type="text" pattern="^[\d\(\) \-]*$"
                    (blur)="blur()" input-field-on-past-filter maxlength="14"
                    (focusout)="EnableReceiveTextMessageCheckBox()" />
                  <div class="cc-validation">
                    <div id="phoneNumberErrorMessage" *ngIf="displayMessage.PhoneNumber">
                      {{ displayMessage.PhoneNumber }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 checkbox receive-text"  *ngIf="lobbyConfiguration && lobbyConfiguration.EnablePhoneNumber &&  lobbyConfiguration.EnableTextMessageNotification">
                  <label>

                    <input class="cc-filter-checkbox" id="receivetextmessages" type="checkbox" kendoCheckBox formControlName="RecieveTextMessage" />
                    {{'_General_Receive_Text_Messages_Text_' | translate }}
                  </label>
                  <span>{{'_Lobby_Data_Rates_Apply_Text_' | translate }}</span>
                  <div class="tab-indent mt-3 d-flex" *ngIf="recieveTextMessage?.value">
                    <!-- <div class="radio me-3">
                      <input id="language" class="" type="radio" formControlName="PreferredLanguage" kendoRadioButton
                        [value]="1" checked />
                    </div> -->
                    <!-- <div class="radio me-3">
                      <label>English</label>
                    </div> -->
                    <!-- <div class="radio me-3">
                      <input id="language" formControlName="PreferredLanguage" class="" type="radio" kendoRadioButton
                        [value]="3" />
                    </div>
                    <div class="radio me-3">
                      <label> Spanish </label>
                    </div> -->
                  </div>
                </div>

                <div id="enableEmailAddress" class="col-md-6 input"
                  *ngIf="lobbyConfiguration && lobbyConfiguration.EnableEmailAddress">
                  <label for="email">{{'_General_Email_Address_Text_' | translate }}</label>
                  <input id="email" class="form-control" formControlName="EmailAddress" type="email" maxlength="256"
                    (keypress)="keypress($event)" (blur)="blur()" input-field-on-past-filter
                    pattern="^((?=[^<>&])[A-Za-z0-9`\s\|!@?#\\$\/%\[\]^_*\(\)~=\{\}:;+'&quot;.\-;,])*$" />
                  <div class="cc-validation">
                    <div *ngIf="displayMessage.EmailAddress !=''" id="emailAddressErrorMessage">
                      {{ displayMessage.EmailAddress }}
                    </div>
                  </div>
                </div>

                <div id="enableDateOfBirth" class="col-md-6 input"
                  *ngIf="lobbyConfiguration && lobbyConfiguration.EnableDateOfBirth">
                  <label for="dob">{{'_General_DOB_Text_' | translate }}</label>
                  <input id="dob" class="form-control" formControlName="DateOfBirth" type="date" min="1900-01-01"
                    [max]="dateSelectionMaxLimit" (blur)="convertInvalidDate($event)" />
                </div>
              </div>

              <!-- Additional Comments -->
              <!--*ngIf="lobbyConfiguration && lobbyConfiguration.EnableCustomField"-->
              <div id="enableCustomField" class="input" *ngIf="lobbyConfiguration && lobbyConfiguration.EnableCustomField">
                <label for="additionalComments">{{'_Custom_Field_Text_' | translate}}
                </label>
                <input id="additionalComments" class="form-control" formControlName="CustomFieldValues" type="text"
                  maxlength="250" (keypress)="keypress($event)" (blur)="blur()" input-field-on-past-filter
                  pattern="^((?=[^<>&])[A-Za-z0-9`\s\|!@?#\\$\/%\[\]^_*\(\)~=\{\}:;+'&quot;.\-;,])*$" />
                <div id="customFieldErrorMessage" class="cc-validation">
                  <div *ngIf="displayMessage.CustomFieldValues">
                    {{ displayMessage.CustomFieldValues }}
                  </div>
                </div>
              </div>

              <!-- Notes -->
              <div class="input mt-3 mb-0">
                <label for="notes">{{'_General_Notes_Info_Text_' | translate }}</label>
                <input id="notes" class="form-control" formControlName="Notes" type="text" maxlength="500"
                  (keypress)="keypress($event)" (blur)="blur()" input-field-on-past-filter
                  pattern="^((?=[^<>&])[A-Za-z0-9`\s\|!@?#\\$\/%\[\]^_*\(\)~=\{\}:;+'&quot;.\-;,])*$" />
                <div class="cc-validation">
                  <div id="notesErrorMessage" *ngIf="displayMessage.Notes">
                    {{ displayMessage.Notes }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Staff Preference -->
            <div class="col-md-6 d-flex flex-column">
              <!--Title-->
              <h6 class="sub-heading">{{'_Lobby_Staff_Preference_Text_' | translate }}</h6>

              <div class="row">
                <div class="col-md-6 dropdown">
                  <!-- Staff Member -->
                  <div>
                    <label for="staffMember">{{'_Lobby_Staff_Member_Text_' | translate }}
                      <span tabindex="-1" *ngIf="lobbyConfiguration && lobbyConfiguration.MakeStaffMemberSelectionMandatory"  class="required-field">*</span>
                    </label>
                    <select class="cc-select-dropdown form-control" id="staffMember" placeholder="_General_Select_Text_ | translate "               
                      formControlName="UserRequested">
                      <option value="-1">{{'_General_Select_Text_' | translate }}</option>
                      <option *ngFor="let staffMember of staffMembers$ | async" [ngValue]="staffMember">
                        {{ staffMember.firstName }} {{ staffMember.lastName }}
                      </option>
                    </select>
                    <div class="cc-validation">
                      <div id="staffRequiredErrorMessage" *ngIf="lobbyCheckInForm.get('UserRequested')?.touched && lobbyCheckInForm.get('UserRequested')?.errors?.required && staffMemberRequiredMessage">
                        {{ staffMemberRequiredMessage }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6 checkbox spanish-speaker">
                  <label>
                    <input class="cc-filter-checkbox" id="spanishSpeaker" type="checkbox" kendoCheckBox
                      (click)="spanishSpeakerCheckBoxClick($event)"
                      [checked]="spanishSpeakerPrefferChecked$ | async" />
                      {{'_General_Notes_ES_Speaker_Text_' | translate }}
                  </label>
                </div>
              </div>

              <div class="reason-for-visit">
                <div class="row">
                  <div class="col-md-6">
                    <h6 class="sub-heading">{{'_General_Reasons_To_Visit_Text_' | translate }}</h6>
                  </div>
                  <div class="col-md-6 reason-for-visit-actions">
                    <div>
                      <button class="cc-icon-btn">
                        <img class="sort-icon" *ngIf="sortdedAscending" src="assets/images/icon/sort-alpha-up-solid.svg" alt="" (click)="sortServices()"/>
                        <img class="sort-icon"  *ngIf="!sortdedAscending" src="assets/images/icon/sort-alpha-down-solid.svg" alt="" (click)="sortServices()" />                   
                      </button>
                    </div>
                    <div class="cc-popup-search">
                      <input id="kioskConfigSearchText" class="form-control" type="text" placeholder="{{'_General_Search_Text_' | translate }}" [(ngModel)]="serviceFilterValue"
                        [ngModelOptions]="{ standalone: true }" (keypress)="serviceFilterKeyPress($event)"
                        (ngModelChange)="clearServiceFilterWhenEmpty()" />
                      <button id="clearServiceFilter" [ngClass]="{ 'show-btn': serviceFilterValue.length > 0 }"
                        class="cc-close-btn" (click)="clearServiceFilter()">
                        <span class="fas fa-times"></span>
                      </button>
                      <button id="kioskConfigSearchButton" type="button" class="cc-search-btn">
                        <span id="serviceFilter" class="fas fa-search" (click)="serviceFilter()">
                        </span>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="psPanel">
                  <!--  Without Category -->
                  <div id="doNotShowCategoriesInLobby" class="ps-list"
                    *ngIf="lobbyConfiguration && !lobbyConfiguration.ShowCategoriesInLobby">
                    <ul>

                      <li *ngFor="let service of lobbyServices; let i = index">
                        <button id="{{'serviceRequested' +i}}" [ngClass]="{
                            selected: lobbyCheckIn.ServiceRequested.includes(
                              service.service.id
                            )
                          }" (click)="serviceCheckBoxClick(service.service.id)">
                          <i class="far fa-square me-2"></i>
                          <i class="fas fa-check-square me-2"></i>
                          {{ service.service.name }}
                          <!-- <i class="fas fa-check"></i> -->
                        </button>
                      </li>
                    </ul>
                  </div>

                  <!-- With Category -->

                  <div id="showCategoriesInLobby" class="ps-list-with-category"
                  *ngIf="lobbyConfiguration && lobbyConfiguration.ShowCategoriesInLobby">
                    <ngb-accordion [closeOthers]="false" class="cc-accordion category-list">
                      <ngb-panel id="{{ serviceWithCategory.catName }}" title="" *ngFor="
                          let serviceWithCategory of lobbyServices">
                        <ng-template ngbPanelTitle>
                          <span>{{ serviceWithCategory.catName }}</span>
                          <span class="caret"></span>
                        </ng-template>
                        <ng-template ngbPanelContent>
                          <div class="ps-list">
                            <ul>
                              <li *ngFor="let service of serviceWithCategory.service">
                                <button class="ps-category-button" id="{{'serviceRequested' + service.service.id}}" [ngClass]="{
                                    selected:
                                      lobbyCheckIn.ServiceRequested.includes(
                                        service.service.id
                                      )
                                  }" (click)="serviceCheckBoxClick(service.service.id)">
                                  <i class="far fa-square me-2"></i>
                                  <i class="fas fa-check-square me-2"></i>
                                  {{ service.service.name }}
                                  <!-- <i class="fas fa-check"></i> -->
                                </button>
                              </li>
                            </ul>
                          </div>
                        </ng-template>
                      </ngb-panel>
                    </ngb-accordion>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Check-in Button Panel -->
        <div class="check-in-btn-panel">
          <div>
            <button id="toApptStatus" class="btn btn-primary" (click)="routeToLobbyAppointmentStatus()">
              {{'_Lobby_Today_Appointments_Text_' | translate }}
            </button>
          </div>
          <div class="action-btn">
            <button id="closeBtn" class="btn btn-secondary" (click)="close()">{{'_General_Button_Cancel_Text_' | translate }}</button>
            <button id="addToLobbyBtn" class="btn btn-primary" (click)="addToLobby($event)"
              [disabled]="lobbyCheckInForm.invalid || lobbyCheckInForm.pristine">
              {{'_Lobby_Add_To_Lobby_Text_' | translate }}
            </button>

            <span [attr.title]="!isUserSigned ? signinInstantlyAssistText : null">
            <button id="instantAssistBtn" class="btn btn-primary" (click)="instantAssist()"
              [disabled]="lobbyCheckInForm.invalid || lobbyCheckInForm.pristine || !isUserSigned || isAssisting">
              {{'_General_Instant_Assist_Text_' | translate }}
            </button>
          </span>
            
          <span [attr.title]="!isUserSigned ? lobbyCheckInSigninForAssistText : null">
            <button *ngIf="enableUserImpersonation && enableUserImpersonationForTenant"  id="instantImpersonateAssistBtn" class="btn btn-primary"  [title]="!isUserSigned ?  signinForAssistText :''" (click)="instantImpersonateAssist()"
              [disabled]="lobbyCheckInForm.invalid || lobbyCheckInForm.pristine || !isUserSigned">
              {{'_Lobby_CheckIn_Instant_Assist_Impersonate_Text_' | translate }}
            </button>
          </span>
          </div>
        </div>
      </div>
  </kendo-dialog>
</form>

<!-- <kendo-dialog id="reset-link-dialog" title="Select Account Member Name" *ngIf="isAccountMemberPopupVisible" (close)="closeAccountMemberPopup()" [minWidth]="250"
              [width]="650">
              <div class="table-wrapper">
                <table class="table table-striped table-borderless">
                  <tbody>
                    <tr *ngFor="let item of filteredList">
                      <td>{{item}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
  <kendo-dialog-actions class="cc-btn-panel">
    <button type="button" id="cancel-dialog" class="btn btn-secondary" (click)="close()"
            primary="true">
      Cancel
    </button>
  </kendo-dialog-actions>
</kendo-dialog> -->
<app-instant-impersonate-assist  
  header="{{'_Lobby_CheckIn_Impersonate_Assist_Text_' | translate}}"
  [(locationId)]="_locationId"
  message=" {{'_Lobby_Central_Assist_Eligible_User_Text_' | translate}} {{_locationName}}{{'_Lobby_Central_Assist_Eligible_User_Select_Text_' | translate}}" 
  actionYesLabel="{{'_General_Assist_Text_' | translate}}"
  actionNoLabel="{{'_General_Button_Close_Text_' | translate }} "
  [(lobbyEntry)]="currentLobbyEntry"
  (ImpersonateUserSelected)=OnUserSelected($event)
   >
</app-instant-impersonate-assist>
